import React from 'react';
import './CancelPopup.css';
import CrossIcon from "../../assets/images/cross.svg"
import WarningIcon from "../../assets/images/warning.svg"

const CancelPopup = ({ onClose, onConfirm }) => {
  return (
    <div className="popup-container" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className='top'>
        <h2 className="popup-title">Confirmation</h2>

        </div>
        <img src={CrossIcon} className='close-button' onClick={onClose}></img>
        <div className="warning-box">
          <img src={WarningIcon} className='warning-icon' onClick={onClose}></img>

          <p className="warning-text">
            Please be aware that after your account has been cancelled, you will need to set up your profile again if you decide to rejoin MyFriend. Any unsaved conversations will be lost.
          </p>
        </div>
        <p className="popup-message">Are you sure you want to cancel your subscription?</p>
        <div className="popup-actions">
          <button className="go-back-btn" onClick={onClose}>Go Back</button>
          <button className="confirm-btn" onClick={onConfirm}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default CancelPopup;